export function getQueryParam(paramName: string, customWindow?: Window | null) {
  const searchParams = new URLSearchParams((customWindow || window).location.search);
  return searchParams.get(paramName) || '';
}
